export const environment = {
  production: false,
  name: "(DEV)",
  // apiBaseUrl: "https://devapi.lil-champs.com/littlechamp/api"
  apiBaseUrl: "https://api.lil-champs.com/littlechamp/api"

};

